import {
    ACCOUNTANT_LEGAL_ENTITY_APPROVE,
    CONSIGNOR_DIRECTOR_PERMISSION,
    LAWYER_LEGAL_ENTITY_APPROVE,
    LOGIST_LEGAL_ENTITY_APPROVE,
    PERSONAL_RESPONSIBILITY_LEGAL_ENTITY_APPROVE,
    SERVICE_INFORMATION_MANAGEMENT,
    SUPPORT_LEGAL_ENTITY_APPROVE,
    VIEW_COMPANY_PAGE,
} from "../../helpers/user_permission.helper";

function hasPermission(userInfo, permissionName) {
    return (
        Array.isArray(userInfo.permissions) &&
        userInfo.permissions.some(
            (permission) =>
                permission &&
                permission.Name === permissionName
        )
    );
}

export function resolveProfileDestination(
    userInfo = {},
    organization = {}
) {
    if (userInfo.role === "driver") {
        return "/driver";
    }

    if (
        hasPermission(
            userInfo,
            SUPPORT_LEGAL_ENTITY_APPROVE
        ) ||
        hasPermission(
            userInfo,
            CONSIGNOR_DIRECTOR_PERMISSION
        )
    ) {
        return "/consignor/staff-users";
    }

    if (
        hasPermission(
            userInfo,
            ACCOUNTANT_LEGAL_ENTITY_APPROVE
        ) ||
        hasPermission(
            userInfo,
            LAWYER_LEGAL_ENTITY_APPROVE
        ) ||
        hasPermission(
            userInfo,
            LOGIST_LEGAL_ENTITY_APPROVE
        ) ||
        hasPermission(
            userInfo,
            PERSONAL_RESPONSIBILITY_LEGAL_ENTITY_APPROVE
        )
    ) {
        return "/consignor/companies-list";
    }

    if (
        organization.context === "company" ||
        userInfo.userType === "carrier" ||
        hasPermission(userInfo, VIEW_COMPANY_PAGE)
    ) {
        return "/company/car-park";
    }

    if (
        organization.context === "consignor" ||
        userInfo.userType === "consignor"
    ) {
        return "/consignor/user-notification";
    }

    if (
        hasPermission(
            userInfo,
            SERVICE_INFORMATION_MANAGEMENT
        )
    ) {
        return "/settings";
    }

    return "/start";
}
